import { useData, useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import ListGroup from "react-bootstrap/ListGroup";

import TimeFormat from "./TimeFormat.js";
import MoneyFormat from "./MoneyFormat.js";

export default function CompanyModal (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    function closeCompany () { gDispatch({ type: "closeModal", modal: "company" }); }

    if (gData.state.currentThemeId === null) return (<></>);
    
    const theme = gData.state.themes[gData.state.currentThemeId];
    const themeContent = gData.content.themes[theme.id];

    // TIME
    let timeGroup = (<></>);

    if (gData.state.currentThemeId !== null)
    {
	const timeLeft = themeContent.endTime - gData.state.time;
	const minLeft = timeLeft % 60;
	const hourLeft = (timeLeft - minLeft) / 60;

	const minLeftStr = minLeft + " minute" + (minLeft > 1 ? "s" : "");
	const hourLeftStr = hourLeft + " heure" + (hourLeft > 1 ? "s" : "");
	const timeLeftStr = (hourLeft > 0 ? hourLeftStr : "")
			  + (hourLeft > 0 & minLeft > 0 ? " et " : "")
			  + (minLeft > 0 ? minLeftStr : "");
	
	let timeClasses = "fw-bold ";
	if (timeLeft > 120) timeClasses += "text-success";
	else timeClasses += "text-danger";
	
	const timeStr = timeLeft <= 0 ?
			(
			    <span className="fw-bold">C'est l'heure de rendre votre rapport.</span>
			) :
			(
			    <span>
				<span>Il vous reste </span>
				<span className={timeClasses}>{timeLeftStr}</span>
				<span> avant de rendre votre rapport.</span>
			    </span>
			);
	
	timeGroup = (
	    <div>
		<div>
		    <span>Temps</span>
		    <TimeFormat value={gData.state.time}/>
		</div>
		<div>
		    {timeStr}
		</div>
	    </div>
	);
    }

    // MONEY
    const moneyGroup = (
	<div>
	    <span>Fonds</span>
	    <MoneyFormat value={gData.state.money}/>
	</div>
    );
    
    // VARIABLES
    const variableItems = Object.entries(gData.state.variables).map(([id, variable]) => {
	const variableContent = gData.content.variables[id];
	return (
	    <ListGroup.Item key={id} className="d-flex justify-content-between">
		    <span>{variableContent.title}</span>
		    <span>{variable.value}</span>
	    </ListGroup.Item>
	);
    });

    const variableList = (<ListGroup>{variableItems}</ListGroup>);
    
    return (
	<Modal
	    dialogClassName="modal-lg"
	    show={gData.state.showModals.company}
	    onHide={closeCompany}
	>
	    <Modal.Header closeButton>
		<Modal.Title>État de l'entreprise</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		{timeGroup}
		{moneyGroup}
		{variableList}
	    </Modal.Body>
	</Modal>
    );
}
